import { getUserCanPublishAsCommercialOwner } from '../../../../shared/services/commercialOwner';

export default ['httpApi', 'logger', 'addFormService', (httpApi, logger, addFormService) => {
  const service = {};

  service.canPublishAsCommercialOwner = async () => {
    const { canPostAsOwner } = await getUserCanPublishAsCommercialOwner({
      httpApi,
      logger,
      parameters: { offerId: addFormService.getFieldValue('id') },
    });

    return canPostAsOwner;
  };

  return service;
}];
